import {
  Box,
  Button,
  LinearProgress,
  Paper,
  Toolbar,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { default as React, useEffect, useRef, useState } from "react";
import StopRoundedIcon from "@mui/icons-material/StopRounded";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TableHeaderDropdown from "../../../components/Common/TableHeaderDropdown";
import { theme } from "../../../components/theme";
import DownloadIcon from "@mui/icons-material/Download";
import CustomPagination from "../../../components/Common/CustomPagination";
import { Table, TableContainer } from "@mui/material";
import ProjectsTableBody from "./ProjectTableBody";
import NestedTableHead from "../../../components/Common/NestedTableHead";
import { useQualityData } from "../../../context/QualityDataContext";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ClearIcon from "@mui/icons-material/Clear";
import moment from "moment";
import PredictionParts from "./PredictionParts";
import DateRangeFilter from "../../../components/Common/DateRangeFilter";
import DataTable from "./DataTable";
import CropSquareRoundedIcon from "@mui/icons-material/CropSquareRounded";
import { customDateConvert } from "../../../components/Common/Utils/Utils";
import useApi from "../../../service/api.service";
import { useLoading } from "../../../context/LoadingContext";
import TableSkeleton from "../../operator/Components/TableSkeleton";
import * as XLSX from "xlsx";
import toast, { Toaster } from "react-hot-toast";
import ActualParts from "./ActualParts";

function QualityTable({ finalDate, dateRange }) {
  const filterContainerStyle = {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  };
  const textStyle = {
    fontSize: "12px",
    marginRight: "10px",
    fontWeight: "500",
  };
  const styles = {
    headerBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      // mb: 1,
      p: 1,
    },
    titleTypography: {
      display: "flex",
      alignItems: "center",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
    },
    subtitleTypography: {
      color: "#9F9F9F",
      fontSize: "10px",
    },
    searchBox: {
      alignItems: "center",
      display: "flex",
      padding: "10px",
      justifyContent: "space-between",
      borderBottom: "1px solid gray",
    },
    inputBase: {
      borderRadius: "20px",
      width: "85%",
      height: "32px",
      border: "1px solid #9F9F9F",
      mr: 2,
    },
    searchIcon: {
      color: "#9F9F9F",
      ml: "3px",
      mr: "-3px",
      width: "20px",
      height: "20px",
    },
    filterIcon: {
      color: "white",
      borderRadius: "50%",
      backgroundColor: "#0077B6",
      fontSize: "30px",
      padding: "5px",
      marginRight: "5px",
      cursor: "pointer",
    },
    keyDownIcon: {
      fontSize: "17px",
      ml: 0.2,
      mr: 1,
    },
    headerBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      // mb: 1,
      p: 1,
    },
  };

  const API = useApi();
  const [filterParts, setFilterParts] = useState("All");
  const [filterActualParts, setFilterActualParts] = useState("All");
  const [anchorEl, setAnchorEl] = useState(null);
  const [data, setData] = useState(null);
  const { loading, setLoading } = useLoading();
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [selectedItem, setSelectedItem] = useState("By Parts");
  const [filteredRows, setFilteredRows] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [paginationData, setPaginationData] = useState({});
  const [order, setOrder] = useState("desc");
  const intervalRef = useRef(null);
  const [realTimeData, setRealTimeData] = useState(false);
  // const [dateRange, setDateRange] = useState([
  //   {
  //     startDate: null,
  //     endDate: null,
  //     key: "selection",
  //     enabled: false,
  //     status: false,
  //   },
  // ]);
  // const [finalDate, setFinalDate] = useState({
  //   startDate: null,
  //   endDate: null,
  // });

  const fetchData = async () => {
    // console.log(finalDate, filterParts);
    const customParams = {
      startTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      statusType: filterParts,
      actualStatusFilter: filterActualParts,
      page: currentPage,
      limit: itemsPerPage,
      orderColumn: "dryTunelExitTime",
      orderDirection: order.toUpperCase(),
    };

    const customParamsString = JSON.stringify(customParams);
    localStorage.setItem("customParams", customParamsString);

    try {
      setLoading(true);
      const response = await API.fetchQualityTableData(customParams);
      setLoading(false);
      setFilteredRows(response?.data?.parts);
      setPaginationData((prevState) => ({
        ...prevState,
        rowsPerPage: response?.data?.rowsPerPage,
        totalPages: response?.data?.totalPages,
        totalRows: response?.data?.totalRows,
      }));
      // console.log(updatedTable)
      localStorage.setItem("totalPages", response?.data?.totalPages);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const fetchRealTimeData = async () => {
    // console.log(finalDate, filterParts);
    const customParams = {
      startTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      statusType: filterParts,
      actualStatusFilter: filterActualParts,
      page: currentPage,
      limit: itemsPerPage,
      orderColumn: "dryTunelExitTime",
      orderDirection: order.toUpperCase(),
    };

    const customParamsString = JSON.stringify(customParams);
    localStorage.setItem("customParams", customParamsString);

    try {
      const response = await API.fetchQualityTableData(customParams);
      setFilteredRows(response?.data?.parts);
      setPaginationData((prevState) => ({
        ...prevState,
        rowsPerPage: response?.data?.rowsPerPage,
        totalPages: response?.data?.totalPages,
        totalRows: response?.data?.totalRows,
      }));
      // console.log(updatedTable)
      localStorage.setItem("totalPages", response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (realTimeData && order == "desc") {
      if (finalDate.startDate == null || finalDate.endDate == null) {
        fetchRealTimeData();
      } else if (isDateInRange(finalDate.startDate, finalDate.endDate)) {
        fetchRealTimeData();
      }
      const interval = setInterval(() => {
        if (!dateRange[0].enabled) {
          fetchRealTimeData();
        } else if (isDateInRange(finalDate.startDate, finalDate.endDate)) {
          fetchRealTimeData();
        }
      }, 20000);

      return () => clearInterval(interval);
    }
  }, [
    finalDate,
    filterParts,
    currentPage,
    itemsPerPage,
    realTimeData,
    order,
    filterActualParts,
  ]);

  useEffect(() => {
    if (!isDateInRange(finalDate.startDate, finalDate.endDate)) {
      fetchData();
    }
  }, [
    finalDate,
    filterParts,
    currentPage,
    itemsPerPage,
    order,
    filterActualParts,
  ]);

  // useEffect(()=>{
  //   fetchData();
  // },[])

  const isDateInRange = (startDate, endDate) => {
    const currentDate = new Date();
    return startDate <= currentDate && currentDate <= endDate;
  };

  const getRealTimeData = async () => {
    try {
      setLoading3(true);
      const response = await API.getRealTimeData();
      setLoading3(false);
      const realTimeFlag = response?.data;
      setRealTimeData(realTimeFlag?.flag);
      if (realTimeFlag?.flag) {
        clearInterval(intervalRef.current);
      }
    } catch (error) {
      setLoading3(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getRealTimeData();
    intervalRef.current = setInterval(() => {
      getRealTimeData();
    }, 20000);

    return () => clearInterval(intervalRef.current);
  }, []);

  const [columns, setColumns] = useState([
    [
      { title: "Timestamp", colSpan: 1 },
      { title: "Part ID", colSpan: 1 },
      { title: "Prediction", colSpan: 1 },
      { title: "Actual", colSpan: 1 },
      { title: "Product ID", colSpan: 1 },
      { title: "OPS", label: "Off Paternoster Since", colSpan: 1 },
      { title: "Contribution", colSpan: 5 },
    ],
    [{}, {}, {}, {}, {}, {}],
  ]);

  // useEffect(() => {
  //   if (partsData.length > 0) {
  //     const firstPartFactors = partsData[0].factors.map((factor) => ({
  //       title: factor.factorName,
  //       colSpan: 1,
  //     }));

  //     setColumns((prev) => [prev[0], [...prev[1], ...firstPartFactors]]);
  //   }
  // }, []);
  useEffect(() => {
    if (filteredRows?.length > 0) {
      const firstPartFactors = filteredRows[0].factors.map((factor) => {
        const title = factor.factorName
          .split(" ")
          .map((word) => word.charAt(0))
          .join("");
        return {
          title: title.toUpperCase(),
          label: factor.factorName,
          colSpan: 1,
        };
      });

      setColumns([
        [
          { title: "Timestamp", colSpan: 1 },
          { title: "Part ID", colSpan: 1 },
          { title: "Prediction", colSpan: 1 },
          { title: "Actual", colSpan: 1 },
          { title: "Product ID", colSpan: 1 },
          { title: "OPS", label: "Off Paternoster Since", colSpan: 1 },
          {
            title: "Contributing Factors",
            colSpan: filteredRows[0].factors.length,
          },
        ],
        [{}, {}, {}, {}, {}, {}, ...firstPartFactors],
      ]);
    }
  }, [filteredRows]);

  const handleMenuItemClick = (selectedItem) => {
    setSelectedItem(selectedItem);
    handleClose();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [toggleDateFilter, setToggleDateFilter] = useState(false);

  const handleSelectedItem = (selectedItemData) => {
    setData(selectedItemData);
  };

  const totalPages = paginationData.totalPages;

  const handleChangePage = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeItemsPerPage = (items) => {
    setItemsPerPage(items);
    setCurrentPage(1);
  };

  const [search, setSearch] = useState("");

  const fetchDataDownload = async () => {
    const customParams = {
      startTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      statusType: filterParts,
      actualStatusFilter: filterActualParts,
      page: currentPage,
      limit: itemsPerPage,
      orderColumn: "dryTunelExitTime",
      orderDirection: order.toUpperCase(),
      downloadFlag: true,
    };

    try {
      setLoading2(true);
      const response = await API.fetchQualityTableData(customParams);
      if (response?.data?.length > 0) {
        handleDownload(response?.data);
        toast.success("Data downloaded successfully");
      } else {
        toast.error("No data to download");
      }
      setLoading2(false);
    } catch (error) {
      setLoading2(false);
      console.error("Error fetching data:", error);
    }
  };

  const handleDownload = (data) => {
    const uniqueFactors = [
      ...new Set(
        data.flatMap((item) => item.factors.map((factor) => factor.factorName))
      ),
    ];

    const transformedData = data.map((item) => {
      const factorValues = uniqueFactors.reduce((acc, factorName) => {
        const factor = item.factors.find((f) => f.factorName === factorName);
        acc[factorName] = factor ? factor.contribution : null;
        return acc;
      }, {});

      const {
        partSystemId,
        productSystemId,
        partCode,
        productCode,
        factors,
        final_status,
        actualStatus,
        dryTunnelExitTime,
        ...rest
      } = item;

      return {
        "Dry Tunnel Exit Time": customDateConvert(
          dryTunnelExitTime,
          "MM/DD/YYYY HH:mm:ss"
        ),
        "Part Id": partCode,
        "Final Status": final_status,
        "Actual Status": actualStatus,
        "Product Id": productCode,
        ...factorValues,
      };
    });

    const ws = XLSX.utils.json_to_sheet(transformedData);

    const setColumnWidths = (worksheet, data) => {
      const columnHeaders = Object.keys(data[0]);
      const columnWidths = columnHeaders.map((header, colIndex) => {
        const headerLength = header.length;
        const maxLength = data.reduce((max, row) => {
          const valueLength = row[header] ? row[header].toString().length : 0;
          return Math.max(max, valueLength);
        }, headerLength);
        return { wch: maxLength * 1.2 }; // Add some padding
      });
      worksheet["!cols"] = columnWidths;
    };

    // Set column widths
    setColumnWidths(ws, transformedData);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Partwise Factors Summary");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

    const s2ab = (s) => {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    };

    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);

    const oneDay = 24 * 60 * 60 * 1000;
    const oneWeek = 7 * oneDay;
    const defaultStartDate = new Date(Date.now() - oneWeek);
    const defaultEndDate = new Date(Date.now() - oneDay);
    const startDate = finalDate.startDate
      ? new Date(finalDate.startDate)
      : defaultStartDate;
    const endDate = finalDate.endDate
      ? new Date(finalDate.endDate)
      : defaultEndDate;

    const a = document.createElement("a");
    a.href = url;
    a.download = `Scrap Prediction Summary From ${customDateConvert(
      startDate,
      "MM-DD-YYYY"
    )} To ${customDateConvert(endDate, "MM-DD-YYYY")}.xlsx`;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  };

  const onDownload = () => {
    fetchDataDownload();
  };

  return (
    <>
      <Box sx={styles.headerBox}>
        {/* <Box sx={{ flexDirection: "column", padding: "5px 20px" }}>
          <Typography sx={styles.titleTypography} onClick={handleClick}>
            {selectedItem}
            <KeyboardArrowDownIcon sx={styles.keyDownIcon} />
          </Typography>
          <TableHeaderDropdown
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorEl={anchorEl}
            items={["By Parts", "By Products"]}
            handleMenuItemClick={handleMenuItemClick}
          />
          <Typography sx={styles.subtitleTypography}>
            {data?.length} Parts &bull; Updated {""}
          </Typography>
        </Box>
        <IconButton
          variant="contained"
          sx={{
            backgroundColor: "#0077B6",
            padding: "4px",
            marginRight: "10px",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#0077B6",
              color: "white",
            },
          }}
          onClick={onDownload}
        >
          <DownloadIcon
            sx={{
              fontSize: "20px",
            }}
          />
        </IconButton> */}
        <Typography
          component="div"
          sx={{
            fontSize: "20px",
            color: "#404040",
            fontWeight: "500",
            whiteSpace: "nowrap",
          }}
        >
          By Parts
        </Typography>
        <div style={filterContainerStyle}>
          <>
            <div
              style={{
                marginRight: "15px",
                display: "flex",
                alignItems: "center",
                gap: "7px",
                fontSize: "12px",
                fontWeight: 400,
                border: "1px solid #DEDEDE",
                borderRadius: "25px",
                padding: "8px 10px",
              }}
            >
              <div
                style={{
                  padding: "6px",
                  border: "2px solid #F5A9A3",
                  borderRadius: "3px",
                  backgroundColor: "#EA43351A",
                }}
              ></div>
              Highest Contributing Factor
            </div>
            {/* {dateRange?.[0]?.enabled && (
              <Typography sx={textStyle}>
                From {dateRange?.[0].startDate?.toLocaleDateString("en-US")}
                {" To "}
                {dateRange?.[0].endDate?.toLocaleDateString("en-US")}
              </Typography>
            )}
            {dateRange?.[0]?.enabled && (
              <IconButton
                onClick={() => {
                  setDateRange([
                    {
                      enabled: false,
                      startDate: null,
                      endDate: null,
                      key: "selection",
                      status: false,
                    },
                  ]);
                  setFinalDate({
                    startDate: null,
                    endDate: null,
                  });
                }}
                sx={{
                  backgroundColor: "white",
                  cursor: "pointer",
                  height: "30px",
                  width: "30px",
                  border: "1px solid #e4e4e4",
                  borderRadius: "20px",
                  marginRight: "10px",
                  fontSize: "12px",
                  "&:hover": {
                    backgroundColor: "#e4e4e4",
                    color: "white",
                  },
                }}
              >
                <ClearIcon
                  size="small"
                  sx={{
                    fontSize: "18px",
                  }}
                />
              </IconButton>
            )} */}
          </>
          {/* <>
            <Button
              variant="contained"
              size="small"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                columnGap: 1,
                textTransform: "initial",
                height: "32px",
                width: "140px",
                fontSize: "12px",
                boxShadow: "none",
                backgroundColor: "#fff",
                color: "#404040",
                border: "1px solid #D4D4D4",
                borderRadius: "25px",
                marginRight: "10px",
                "&:hover": {
                  backgroundColor: "#fff",
                  boxShadow: "none",
                },
              }}
              onClick={() => {
                setToggleDateFilter(true);
              }}
            >
              Date Range
              <CalendarMonthIcon sx={{ fontSize: "16px" }} />{" "}
            </Button>
          </> */}
          <>
            <PredictionParts
              filterParts={filterParts}
              setFilterParts={setFilterParts}
            />
            <ActualParts
              filterParts={filterActualParts}
              setFilterParts={setFilterActualParts}
            />
            <IconButton
              variant="contained"
              sx={{
                backgroundColor: "#0077B6",
                padding: "6px",
                marginRight: "10px",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#0077B6",
                  color: "white",
                },
              }}
              onClick={onDownload}
            >
              {loading2 ? (
                <CircularProgress size={22} sx={{ color: "white" }} />
              ) : (
                <DownloadIcon
                  sx={{
                    fontSize: "22px",
                  }}
                />
              )}
            </IconButton>
          </>
        </div>
        {/* {toggleDateFilter && (
          <DateRangeFilter
            open={toggleDateFilter}
            onClose={() => {
              setToggleDateFilter(false);
            }}
            onApply={() => {
              setToggleDateFilter(false);
              setDateRange([
                {
                  ...dateRange?.[0],
                  enabled: true,
                  status: !dateRange?.[0]?.status,
                },
              ]);
              setFinalDate({
                startDate: dateRange?.[0].startDate,
                endDate: dateRange?.[0].endDate,
              });
            }}
            dateRange={dateRange}
            onChange={(data) => {
              setDateRange([
                {
                  ...data?.[0],
                  status: dateRange?.[0]?.status,
                },
              ]);
            }}
          />
        )} */}
      </Box>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          {loading ? (
            <TableSkeleton />
          ) : (
            <>
              <NestedTableHead
                columns={columns}
                order={order}
                setOrder={setOrder}
              />
              <ProjectsTableBody data={filteredRows} />
            </>
          )}
        </Table>
      </TableContainer>
      <Toaster />
      {filteredRows?.length != 0 && (
        <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          changePage={handleChangePage}
          changeItemsPerPage={handleChangeItemsPerPage}
          minRows={10}
        />
      )}
      {/* <DataTable data={partsData} /> */}
    </>
  );
}

export default QualityTable;
